
<div class="is-block is-fullwidth">
  <app-set-point
    [room]="room"
    [module]="module"
    >
  </app-set-point> 

</div>